import { useField } from "formik";
import React from "react";
import { Form } from "react-bootstrap";
import NumberFormat from "react-number-format";
import { FieldLabel } from '@blueprint/ui';

import { GenericFieldProps } from "./common";

const MAX = 100000000000000;

export type AmountFieldProps = GenericFieldProps & {
    disabled?: boolean;
    ariaLabelledBy?: string;
    required?: boolean;
};

const AmountField = ({
    className,
    name,
    label,
    autoFocus,
    disabled,
    ariaLabelledBy,
    required,
}: AmountFieldProps): JSX.Element => {
    const [field, meta, helpers] = useField(name);
    const ariaLabel = ariaLabelledBy ? ariaLabelledBy : `notification-help-${name}`;
    return (
        <>
            <div className={'mb-4 flex-grow-1'}>
                <FieldLabel marginBottom='5px' htmlFor={{name}}>{label}</FieldLabel>
                <NumberFormat
                    className={`amount-form-control form-control ${meta.error ? "is-invalid" : ""}`}
                    thousandSeparator=","
                    decimalScale={2}
                    allowNegative={false}
                    value={field.value}
                    isNumericString
                    onValueChange={(values) => helpers.setValue(values.value)}
                    isAllowed={({ floatValue }) => !floatValue || floatValue < MAX}
                    autoFocus={autoFocus}
                    disabled={disabled}
                    name={name}
                    aria-label={label}
                    aria-labelledby={ariaLabel}
                    aria-describedby={`notification-help-${name}`}
                    required={required}
                >
                </NumberFormat>
                <Form.Control.Feedback type="invalid" className="position-absolute" id={`notification-help-${name}`} style={{color: 'red'}}>
                    {meta.error}
                </Form.Control.Feedback>
            </div>
        </>
    );
};

export default AmountField;
